import { render, staticRenderFns } from "./r-worker-dialog.vue?vue&type=template&id=df79d0b4&scoped=true"
import script from "./r-worker-dialog.vue?vue&type=script&lang=js"
export * from "./r-worker-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-worker-dialog.vue?vue&type=style&index=0&id=df79d0b4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df79d0b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('df79d0b4')) {
      api.createRecord('df79d0b4', component.options)
    } else {
      api.reload('df79d0b4', component.options)
    }
    module.hot.accept("./r-worker-dialog.vue?vue&type=template&id=df79d0b4&scoped=true", function () {
      api.rerender('df79d0b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/worker/r-worker-dialog.vue"
export default component.exports